import { render, staticRenderFns } from "./CustomerAdded.vue?vue&type=template&id=77ec679a&"
import script from "./CustomerAdded.vue?vue&type=script&lang=ts&"
export * from "./CustomerAdded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports